/**
 * Part of a-power project.
 *
 * @copyright  Copyright (C) 2023 __ORGANIZATION__.
 * @license    __LICENSE__
 */

const offcanvas = document.querySelectorAll('.j-menu-offcanvas');
const defaultMenu = document.querySelector('#mobile-menu');
const collapseLinks = defaultMenu.querySelectorAll('[data-bs-toggle="collapse"]');
const headerSection = document.querySelector('.l-header');

offcanvas.forEach((e) => {

  e.addEventListener('show.bs.offcanvas', () => {
    headerSection.classList.add('scrolling');
  });

  e.addEventListener('hide.bs.offcanvas', () => {
    if (document.body.scrollTop > 0 || document.documentElement.scrollTop > 0) {
      headerSection.classList.add('scrolling');
    } else {
      headerSection.classList.remove('scrolling');
    }
  });
});

collapseLinks.forEach((e) => {
  e.addEventListener('click', () => {
    const targetIcon = e.querySelector('i');

    if (switchClass(targetIcon, 'fa-minus', 'fa-plus')) {
      return false;
    }

    if (switchClass(targetIcon, 'fa-plus', 'fa-minus')) {
      return false;
    }

    if (switchClass(targetIcon, 'fa-chevron-down', 'fa-chevron-right')) {
      return false;
    }

    if (switchClass(targetIcon, 'fa-chevron-right', 'fa-chevron-down')) {
      return false;
    }
  });
});

function switchClass(element, add, remove) {
  if (element.classList.contains(remove)) {
    element.classList.remove(remove);
    element.classList.add(add);

    return true;
  }

  return false;
}
